import Product from "../Shared/Product";
import { ThemeContext } from "../../Contexts/ThemeContext";
import { useContext } from "react";
import "./HomePersonalCare.css";
import { Link } from "react-router-dom";
import leaf1 from "../../Images/leaf1.png";

const HomePersonalCare = () => {
  const { summerMakeup } = useContext(ThemeContext);

  // const products = summerMakeup
  const products = summerMakeup?.slice(1, 4);
  // console.log(products);

  return (
    <div className="rele overflow-hidden bg-white pb-16">
      <div className="relative">
        {/* Decorative leaf image for visual aesthetics */}
        <img
          className="w-[120px] lg:w-[300px] z-0 opacity-90 hidden   absolute bottom-0 lg:bottom-[50px] left-[-30px] lg:left-[-80px]"
          alt="Decorative natural leaf element"
          src={leaf1}
          loading="lazy"
        />

        {/* ✅ Semantic landmark for SEO */}

        <div className="bg-gradient-to-b from-[#E6E6E6] to-white h-[15vh]"></div>
        <section
          aria-labelledby="personal-care-heading"
          className={`flex flex-col relative z-10 px-[10px] items-center sm:px-[20px] lg:px-[0px] lg:w-[90%] -mt-4 mx-auto ${
            window.innerWidth >= 1920 ? "2xl:w-[65%]" : "2xl:w-[80%]"
          }`}
        >
          <h2
            id="personal-care-heading"
            className=" text-center text-xl text-accent font-bold  sm:text-2xl "
          >
            Personal Care – Skincare, Haircare & Body Essentials
          </h2>
          <div className=" w-[100px] mx-auto h-1 bg-accent my-6 mb-16"></div>

          {/* ✅ Reels + Product Grid Layout */}
          <div className="flex flex-col lg:flex-row gap-8 w-full ">
            {/* 🎥 LEFT — Reels Video */}
            <div className="lg:w-[30%] w-full flex justify-center lg:justify-start">
              <div className="sticky top-24">
                <video
                  src="https://luvit.com.bd/wp-content/uploads/2026/02/Clariss-Expert-Series-Biotin-Keratin-Shampoos.mp4"
                  autoPlay
                  loop
                  muted
                  playsInline
                  className="w-[360px] h-[460px] object-cover  shadow-lg"
                />
              </div>
            </div>

            {/* 🛍️ RIGHT — Product Cards */}
            <div className="lg:w-[70%] w-full grid grid-cols-2 md:grid-cols-3 xl:grid-cols-3 gap-6">
              {products?.map((product) => (
                <Product key={product?._id} product={product} />
              ))}
            </div>
          </div>

          {/* CTA */}
          {/* <Link
            to="/product-category/personal care"
            className="text-white bg-accent px-10 rounded sm:mt-20 py-2 hover:bg-secondary ease-in-out duration-200 font-bold mb-10"
            title="Explore all Clariss Personal Care Products"
          >
            View More
          </Link> */}
        </section>
      </div>
    </div>
  );
};

export default HomePersonalCare;
